import { find } from 'lodash'

const mapChoicesToValue = (choices, id) => {
  const value = find(choices, { id })
  return value ? value.name : id
}

export default mapChoicesToValue